import React from 'react'
import {injectIntl} from 'react-intl'
import styled from 'styled-components'
import FormControl from '@mui/material/FormControl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Tab from 'components/Tab'

const types = {
	one: 'one',
	multiple: 'multiple'
}

const Tabs = styled.div`
    display: flex;
`

const List = styled.div`
    display: flex;
	margin-top: 20px;
    flex-direction: column;
`

class ExcelImport extends React.PureComponent {
    constructor(props) {
        super(props)

        this.state = {
			type: types.one,
			sheets: props.sheets.length > 1 ? [ ...props.sheets.map(item => item.id) ] : [],
            sheet: props.sheets[0].id,
            fileName: props.sheets[0].name + ' ' + props.fileName,
            nameChange: false,
            entityId: props.entities.length ? props.entities[0].id : 0
        }

    }

    importExcel = () => {
		if (this.state.type === types.one) {
			this.props.importExcel(
				false,
				this.props.sheets.find(item => item.id === this.state.sheet),
				this.state.entityId,
				this.state.fileName,
				this.props.currentModule
			)
		} else {
			const sheets = this.state.sheets.map(item => this.props.sheets.find(obj => obj.id === item))
			this.props.importExcel(
				true,
				sheets,
				null,
				null,
				this.props.currentModule
			)
		}
        
        this.props.handleClose()
    }

    handleChange = (e) => {
        if (this.state.nameChange) {
            this.setState({
                sheet: e.target.value
            })
        } else {
            const name = this.props.sheets.find(item => item.id === e.target.value).name

            this.setState({
                sheet: e.target.value,
                fileName: name + ' ' + this.props.fileName,
            })
        }
    }

    changeEntity = (e) => {
        this.setState({
            entityId: e.target.value
        })
    }

    handleCheck = (e) => {
        this.setState({
            entityId: e.target.checked ? 0 : this.props.entities[0].id
        })
    }

	handleSelect = (e) => {
		const arr = [...this.state.sheets]
		const value = Number(e.target.value)

		if (e.target.checked) {
			arr.push(value)
		} else {
			const index = arr.findIndex(item => item === value)
			arr.splice(index, 1)
		}
		
		this.setState({
			sheets: [...arr]
		})
	}

    render() {
        const {intl, fileName, sheets, entities } = this.props
		const disabled = (this.state.type === types.one && this.state.fileName.replace(/\s/g, '') === '') ||
			(this.state.type === types.multiple && !this.state.sheets.length)

        return (
            <React.Fragment>
                <DialogTitle>
                    {intl.formatMessage({id: "app.confirm_import"}) + ' ' + fileName}
                </DialogTitle>
                <DialogContent>
					{sheets.length > 1 &&
						<Tabs>
							{Object.values(types).map(item =>
								<Tab key={item} active={this.state.type === item} onClick={() => this.setState({ type: item })}>
									{intl.formatMessage({id: `main.excel_import_${item}`})}
								</Tab>
							)}
						</Tabs>
					}
					{this.state.type === types.one ?
						<React.Fragment>
							{!!sheets.length && sheets.length > 1 &&
								<FormControl style={{width: '100%', margin: '20px 0'}} variant="standard">
									<InputLabel>{intl.formatMessage({id: "main.import_select_spreadsheet"})}</InputLabel>
									<Select
										value={this.state.sheet}
										onChange={this.handleChange}
									>
										{sheets.map(item =>
											<MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
										)}
									</Select>
								</FormControl>
							}
							{!!entities.length &&
								<FormControl style={{width: '100%', marginBottom: '10px'}} variant="standard">
									<InputLabel shrink={true}>{intl.formatMessage({id: "main.select_table"})}</InputLabel>
									<Select
										value={this.state.entityId === 0 ? '' : this.state.entityId}
										onChange={this.changeEntity}
										disabled={this.state.entityId === 0}
									>
										{entities.map(item =>
											<MenuItem key={item.id} value={item.id}>{item.singular}</MenuItem>
										)}
									</Select>
								</FormControl>
							}
							<FormControlLabel
								control={
									<Checkbox
										checked={this.state.entityId === 0}
										onChange={this.handleCheck}
										disabled={!this.props.entities.length}
									/>
								}
								label={intl.formatMessage({id: "main.import_into_new_table"})}
							/>
							{this.state.entityId === 0 &&
								<TextField variant="standard"
									style={{width: '100%', marginTop: '10px'}}
									value={this.state.fileName}
									onChange={(e) => this.setState({ fileName: e.target.value, nameChange: true })}
									label={intl.formatMessage({id: "app.new_table_name"})}
									InputLabelProps={{
										shrink: true
									}}
									inputProps={{
										maxLength: global.NAME_MAX_LENGTH
									}}
								/>
							}
						</React.Fragment> :
						<List>
							{sheets.map(sheet =>
								<FormControlLabel
									key={sheet.id}
									control={
										<Checkbox
											checked={this.state.sheets.includes(sheet.id)}
											onChange={this.handleSelect}
											value={sheet.id}
										/>
									}
									label={sheet.name}
								/>
							)}
						</List>	
					}
				</DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    <Button variant="contained"
                        disabled={disabled}
                        onClick={this.importExcel}
                        color="primary"
                    >
                        {intl.formatMessage({id: "app.confirm_import"})}
                    </Button>
                </DialogActions>
            </React.Fragment>
        )
    }
}

export default injectIntl(ExcelImport)
